module.exports = __webpack_public_path__ + "static/media/emptygreystar.83100988.png";